import Vue from "vue";
import Vuex from "vuex";

const state = {
  params: {
    page: 1,
    per_page: 30,
    q: {
      store_name: "",
      activity_name: "",
      region_id: "",
      is_pay: "",
      is_publish: "",
      shop_id: "",
      is_promoted: "",
      special_guest: "",
      start_time_at: "",
      end_time_at: "",
      publish_start_at: "",
      publish_end_at: "",
    },
  },
  region_names: [],
};

const mutations = {
  changeActivityPage(state, val) {
    state.params = val;
  },

  ActivityRegionChange(state, val) {
    state.region_names = val;
  },
};

export default {
  state,
  mutations,
};
